<template>
  <div class="item-container">
    <div class="detail">
      <div class="title">{{ title }}</div>
      <div class="subtitle mb-3">
        <div class="value">
          <i v-if="platform === 'ANDROID'" class="fab fa-android"></i>
          <i v-else-if="platform === 'iOS'" class="fab fa-apple"></i>
          <div v-else>{{ platform }}</div>
          {{ version }}
        </div>
      </div>
      <div class="subtitle">
        <span class="label">สร้างเมื่อ</span>
        <div class="value">{{ createdDate }}</div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable vue/prop-name-casing */
import { toLocaleTH } from "@/lib/dateTime"
import { DateTime } from "luxon"

export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    platform: {
      type: String,
      required: true,
    },
    version: {
      type: String,
      required: true,
    },
    created_at: {
      type: String,
      required: true,
    },
  },
  computed: {
    queryParams() {
      return {
        page: parseInt(this.$route.query.page, 10) || 1,
      }
    },
    createdDate() {
      return this.formatDate(this.created_at)
    },
  },
  watch: {
    "$route.query": async function routeQueryWatcher() {
      await this.setupData()
    },
  },
  methods: {
    formatDate(date) {
      const format = "dd MMMM yyyy"

      return toLocaleTH(DateTime.fromISO(date)).toFormat(format)
    },
    handleCurrentChange(page) {
      const route = {
        name: this.$route.name,
        query: { ...this.$route.query, page },
      }

      this.$router.replace(route)
    },
  },
}
</script>

<style lang="scss" scoped>
.item-container {
  .detail {
    .title {
      font-size: 1.2rem;
      margin-bottom: 5px;
    }

    .label {
      color: #777;
      font-size: 0.9rem;
    }
    .value {
      font-size: 1rem;
    }
  }
  padding: 20px 0;
  border-bottom: 1px solid #dcdfe6;
}
</style>
